export default {
    lang: {
        name: 'Weight'
    }
}